module.exports = __webpack_public_path__ + "static/media/screen_main_plus_4.9254fc88.svg";